import { NextPage } from 'next';
import { CspSetupLinux } from '../../components/TestEds/CspSetupLinux';
import { useBreadcrumbs } from '../../components/_shared/Breadcrumbs/BreadcrumbsContext';

const cspSetupLinuxPage: NextPage = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useBreadcrumbs([
        { title: 'Использование ЭП', href: '/test_eds' },
        { title: 'Установка КриптоПРО CSP в Linux' },
    ]);

    return <CspSetupLinux />;
};

export default cspSetupLinuxPage;
